import { render, staticRenderFns } from "./addDirektur.vue?vue&type=template&id=6f37d580&scoped=true&"
import script from "./addDirektur.vue?vue&type=script&lang=js&"
export * from "./addDirektur.vue?vue&type=script&lang=js&"
import style0 from "./addDirektur.vue?vue&type=style&index=0&id=6f37d580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37d580",
  null
  
)

export default component.exports